exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".make_payment_wrapper[data-v-4fd704e4]{position:relative;text-align:center;margin-left:-15px}.payment-popup-button.disabled[data-v-4fd704e4]{cursor:default;opacity:.8;box-shadow:none}.payment-popup-button.disabled[data-v-4fd704e4]:hover{box-shadow:none}", ""]);

// exports
